import React, { useEffect, useState } from "react";
import "./help.css";
import help from "../../../img/undraw_helpful_sign_re_8ms5.svg";
import { Fade } from "react-awesome-reveal";
import { TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../Notifcation";
import { CreateContacthelpAction } from "../../../redux/actions/ContactAction";
import { ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
const Helpuser = ({ userData }) => {
  const [Name, setName] = useState(userData.Name);
  const [Messagee, setMessage] = useState("");
  const [Phone, setPhone] = useState(userData.PhoneNumber);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [Email, setEmail] = useState(userData.Email);
  const dispatch = useDispatch();

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Name === "" || Phone === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (Messagee === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      CreateContacthelpAction({
        userName: Name,
        phoneNumber: Phone,
        email: Email,
        message: Messagee,
      })
    );
    setLoading(false);
    setIsPress(false);
  };
  const res = useSelector((state) => state.ContactR.Contact);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);

      if (res && res.data) {
        if (res.data.ResponseMessage === "Great, email sent Successfully") {
          notify("تم أرسال الرسالة بنجاح", "success");
        }
      } else {
        notify("الرجاء حاول مرة اخرى", "error");
      }
    }
  }, [loading, res]);
  return (
    <div className="help">
      <div className="container rounded bg-white mt-5 mb-5">
        <div className="row">
          <div className="col-md-6 border-right">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-center">تواصل معنا</h4>
              </div>
              <div className="row mt-3">
                <div className="col-md-12 de mb-2">
                  {" "}
                  <TextField
                    focused
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                             inputProps={{ maxLength: 120 }} 
                type="text"
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم المستخدم
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                  />
                </div>{" "}
                <div className="col-md-12 de mb-2">
                  {" "}
                  <TextField
                    value={Phone}
                     inputProps={{ maxLength: 15 }} 
                type="number"
                    focused
                    onChange={(e) => setPhone(e.target.value)}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        رقم الهاتف
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                  />
                </div>{" "}
                <div className="col-md-12 de mb-2">
                  {" "}
                  <TextField
                    value={Email}
                    focused
                    onChange={(e) => setEmail(e.target.value)}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        البريد الألكتروني
                        <span style={{ color: "red", fontSize: "11px" }}>
                          (أختياري)
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                  />
                </div>{" "}
                <div className="col-md-12 de mb-2">
                  {" "}
                  <TextField
                    multiline
                    value={Messagee}
                             inputProps={{ maxLength: 120 }} 
                type="text"
                    onChange={(e) => setMessage(e.target.value)}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        رسالتك
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    className="are"
                  />
                </div>{" "}
              </div>
              <div className="mt-5 text-center">
                {isPress && loading ? (
                  <button className=" profile-button">
                    <Spinner animation="border" role="status"></Spinner>
                  </button>
                ) : (
                  <button onClick={handlesubmit} className=" profile-button">
                    إرسال
                  </button>
                )}
              </div>
              <div className="wts d-flex justify-content-between align-items-center mb-3">
                <h5 className="text-center">
                  <a
                    style={{ color: "#fff" }}
                    href="https://wa.me/+201001122424">
                    {" "}
                    أو عن طريق الواتساب{" "}
                  </a>
                  <b>
                    {" "}
                    <i className="fa-brands fa-whatsapp"></i>
                  </b>
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <Fade direction="left">
              <div className="p-3 py-5">
                <Fade direction="right">
                  <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                    <img
                      className="mt-5"
                      width="150px"
                      src={help}
                      alt="avatar"
                    />
                  </div>
                </Fade>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Helpuser;
